import { render, staticRenderFns } from "./BaselTests.vue?vue&type=template&id=58b152e6&scoped=true&v-if=baselTests%20%26%26%20basePvItem%20%26%26%20baselTestsItems"
import script from "./BaselTests.vue?vue&type=script&lang=js"
export * from "./BaselTests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b152e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
